import Component from '../../shared/component';

export default class OnboardingSplash extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.redirectUrl = this.$element.data('redirect-url');

    this.$element.modal('show');
    this.$closeButton = this.$element.find('.onboardingSplash-close');

    this.bindEvents();
  }

  bindEvents() {
    this.handleModalHide = this.handleModalHide.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('hide.bs.modal.OnboardingSplash', this.handleModalHide);
    this.$closeButton.on('touchstart click', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('hide.bs.modal.OnboardingSplash', this.handleModalHide);
    this.$closeButton.off('touchstart click', this.handleClick);
  }

  handleClick() {
    this.$element.modal('hide');
  }

  handleModalHide() {
    window.Turbolinks.visit(this.redirectUrl);
  }
}
